import React from 'react';
import Header from '../Components/Header';

const Inbox = () => {
  return <Header>Inbox</Header>;
};

export default Inbox;
